<template>
  <v-flex class="px-3 question">
    <p class="required-block_left mt-3 mb-2">
      {{ $t('sheet.fields_required') }}
    </p>
    <h2 class="header">
      {{ $t('specialist_package.medics.title') }}
    </h2>
    <div class="question">
      <ul class="questions-list">
        <MedicsTitle />
        <ConsentRemote :read-only="readOnly" />
        <MedicalAreas :read-only="readOnly" />
        <FamilyMembers :read-only="readOnly" />
        <ProblemDescription :read-only="readOnly" />
        <ProblemSince :read-only="readOnly" />
        <ReceivingMedicalHelp :read-only="readOnly" />
        <SelfHelp :read-only="readOnly" />
        <TypeOfHelp :read-only="readOnly" />
        <InfoForMedic :read-only="readOnly" />
        <VolunteerHelp :read-only="readOnly" />
        <SpecialistPackageButtons
          :read-only="readOnly"
          type="medics"
          @finish="showModal"
        />
      </ul>
    </div>
    <AppModal
      :close-button="false"
      :visible="saveModal"
      persistent
      @close="closeModal"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark">
          {{ modalTitle }}
        </h2>
      </template>
      <template slot="content">
        <p class="f-1 mb-0">
          {{ modalContent }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              justify-end
              :justify-center="$vuetify.breakpoint.xsOnly"
            >
              <v-flex shrink>
                <v-btn
                  color="sz_violet"
                  @click="goToFamilyPage"
                >
                  {{ $t('buttons.ok') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
  </v-flex>
</template>

<script>
import ConsentRemote from '@/components/SpecialistPackage/Medics/ConsentRemote';
import FamilyMembers from '@/components/SpecialistPackage/Medics/FamilyMembers';
import InfoForMedic from '@/components/SpecialistPackage/Medics/InfoForMedic';
import MedicalAreas from '@/components/SpecialistPackage/Medics/MedicalAreas';
import MedicsTitle from '@/components/SpecialistPackage/Medics/MedicsTitle';
import ProblemDescription from '@/components/SpecialistPackage/Medics/ProblemDescription';
import ProblemSince from '@/components/SpecialistPackage/Medics/ProblemSince';
import ReceivingMedicalHelp from '@/components/SpecialistPackage/Medics/ReceivingMedicalHelp';
import SelfHelp from '@/components/SpecialistPackage/Medics/SelfHelp';
import TypeOfHelp from '@/components/SpecialistPackage/Medics/TypeOfHelp';
import VolunteerHelp from '@/components/SpecialistPackage/Medics/VolunteerHelp';
import SpecialistPackageButtons from '@/components/SpecialistPackage/SpecialistPackageButtons';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'MedicsQuestions',
    components: {
        FamilyMembers,
        InfoForMedic,
        SelfHelp,
        ReceivingMedicalHelp,
        TypeOfHelp,
        ProblemSince,
        ProblemDescription,
        ConsentRemote,
        VolunteerHelp,
        MedicalAreas,
        MedicsTitle,
        AppModal,
        SpecialistPackageButtons
    },
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            saveModal: false,
            isPackageUpdated: false
        };
    },
    computed: {
        modalTitle () {
            return this.$t('specialist_package.medics.modal.title');
        },
        modalContent () {
            return this.isPackageUpdated
                ? this.$t('specialist_package.medics.modal.content_update')
                : this.$t('specialist_package.medics.modal.content_created');
        }
    },
    methods: {
        showModal (val) {
            this.isPackageUpdated = val;
            this.saveModal = true;
        },
        closeModal () {
            this.saveModal = false;
        },
        goToFamilyPage () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        }
    }
};
</script>

<style scoped></style>
